<div class="docType-container">
    <p class="title">Listado Tipo de Documento</p>
    <div class="docType-container-button">
        <div class="docType-group">
            <input type="text" class="form-control" placeholder="Filtrar" (keyup)=filter($event)>
            <mat-icon class="blue-color">search</mat-icon>
        </div>
    </div>
    <table #table class="docType-table" mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="groupDocument">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de documentos</th>
            <td mat-cell *matCellDef="let item">{{item.groupDocument}}</td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripcion</th>
            <td mat-cell *matCellDef="let item">{{item.description}}</td>
        </ng-container>

        <ng-container matColumnDef="groupName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupo de documento</th>
            <td mat-cell *matCellDef="let item">{{item.groupName}}</td>
        </ng-container>

        <ng-container matColumnDef="codeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel de acceso</th>
            <td mat-cell *matCellDef="let item">{{item.codeName}}</td>
        </ng-container>

        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Activo</th>
            <td mat-cell *matCellDef="let item">
                <mat-icon *ngIf="item.active" class="green-color">done</mat-icon>
                <mat-icon *ngIf="!item.active" class="red-color">clear</mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="Acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let item">
                <button mat-icon-button matTooltip="Eliminar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="delete(item.id)">
                    <mat-icon class="red-color">delete</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Editar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="edit(item.id)">
                    <mat-icon class="blue-color">create</mat-icon>

                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
    <div *ngIf="loading" class="report-container-loader">
        <div class="report-loader"></div>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 30, 40, 50, 100]" showFirstLastButtons></mat-paginator>
</div>